module.exports = __webpack_public_path__ + "img/Background_wave.7c33207a.png";